/* src/app/header/header.component.css */
.test-mode {
  color: red;
  font-size: 12px;
  position: absolute;
  right: 0;
  top: 0;
}
/*# sourceMappingURL=header.component.css.map */
